






















import { Component, Prop, Vue } from 'vue-property-decorator'
import Modal from '@/app/ui/components/Modal/index.vue'
import Button from '@/app/ui/components/Button/index.vue'

@Component({
  components: {
    Modal,
    Button,
  },
})

export default class ModalConfirmationUpdate extends Vue {
  @Prop({ default: false }) private visible!: boolean
  @Prop({ default: '' }) private categoryName!: string
}
